<table class="w-full">
  <thead class="sticky top-0 z-10">
    <tr class="border-b border-white/10">
      @for (column of columns; track column.field) {
        <th class="table-header">
          @if (sortable()) {
            <div class="flex cursor-pointer items-center gap-1 transition-colors hover:text-text-primary" (click)="onSort(column.field)">
              {{ column.label }}
              <span class="material-icons lt-sort-icon">{{ sortIcon(column.field) }}</span>
            </div>
          } @else {
            {{ column.label }}
          }
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @if (loading()) {
      <tr>
        <td [attr.colspan]="columns.length" class="lt-empty text-text-muted">Liefertermine werden geladen…</td>
      </tr>
    } @else if (error()) {
      <tr>
        <td [attr.colspan]="columns.length" class="lt-empty text-red-400">Liefertermine konnten nicht geladen werden.</td>
      </tr>
    } @else {
      @for (row of rows(); track trackRow($index, row)) {
        <tr
          class="table-row border-b border-white/6 last:border-b-0"
          [class.cursor-pointer]="clickable()"
          (click)="onRowClick(row)"
        >
          <td class="table-cell border-l-4" [class.border-emerald-400]="row.isBinding" [class.border-transparent]="!row.isBinding">
            <div class="flex items-center gap-4">
              <span class="lt-date-cell font-semibold text-text-primary">{{ formatDate(row.date) }}</span>
              @if (row.isBinding) {
                <span class="lt-badge inline-flex items-center gap-1.5 rounded-full bg-emerald-400/15 font-semibold text-emerald-400">
                  <span class="material-icons lt-badge-icon">check</span>
                  sicher
                </span>
              }
            </div>
          </td>
          <td class="table-cell font-semibold text-text-primary">{{ row.auftragsNr || '—' }}</td>
          <td class="table-cell text-text-secondary">{{ row.kunde || '—' }}</td>
          <td class="table-cell text-text-secondary">{{ formatPalletBox(row) }}</td>
          <td class="table-cell text-text-secondary">{{ formatGurtbreite(row) }}</td>
          <td class="table-cell text-text-secondary">{{ formatWerk(row) }}</td>
          <td class="table-cell max-w-[32rem] !whitespace-normal text-text-secondary">{{ row.label || '—' }}</td>
        </tr>
      } @empty {
        <tr>
          <td [attr.colspan]="columns.length" class="lt-empty text-text-muted">{{ emptyMessage() }}</td>
        </tr>
      }
    }
  </tbody>
</table>
